import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const TOKEN_KEY = 'la_maria_admin_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

// axios instance with auto 401 handling
const client = axios.create({ baseURL: API_BASE });

client.interceptors.request.use((config) => {
  const t = getToken();
  if (t && config.url && config.url.startsWith('/admin')) {
    config.headers = { ...(config.headers || {}), Authorization: `Bearer ${t}` };
  }
  return config;
});

client.interceptors.response.use(
  (resp) => resp,
  (err) => {
    if (err.response?.status === 401 && err.config?.url?.startsWith('/admin')) {
      // stale/invalid token -> force re-login
      clearToken();
      if (!window.location.pathname.endsWith('/lamariaadmin')) {
        window.location.href = '/lamariaadmin';
      } else {
        // Trigger a soft reload so AdminPage re-checks and shows login form
        window.dispatchEvent(new Event('la_maria_auth_expired'));
      }
    }
    return Promise.reject(err);
  }
);

export const api = {
  getMenu: async () => (await client.get('/menu')).data,
  login: async (password) => {
    const { data } = await client.post('/admin/login', { password });
    setToken(data.token);
    return data;
  },
  logout: () => clearToken(),
  adminGetMenu: async () => (await client.get('/admin/menu')).data,
  instantUpdate: async (menu, week) => (await client.post('/admin/menu/instant', { menu, week })).data,
  schedule: async (menu, hours, minutes, week) =>
    (await client.post('/admin/menu/schedule', { menu, hours, minutes, week })).data,
  cancelSchedule: async () => (await client.post('/admin/menu/cancel-schedule', {})).data,
};
